import styled from 'styled-components';
import { useGetExactSearchQuery, useGetSearchQuery } from 'hooks/queries/search';
import { useSearchParams } from 'react-router-dom';
import ResultNone from '../common/ResultNone';
import style from 'styles/styled-components/style';
import CoreLoading from 'shared/CoreLoading';
import SearchResultList from './SearchResultList';

const SearchResult = () => {
	const [search_params] = useSearchParams();
	const keyword_query = search_params.get('keyword') ?? '';

	// query
	const { data: exact_search_data = null } = useGetExactSearchQuery(keyword_query);
	const {
		data = null,
		isLoading,
		isFetching,
		isFetchingNextPage,
	} = useGetSearchQuery(keyword_query);

	const dummy_regex = /[a-zA-Z\d_.]+/i;
	const dummy_test = dummy_regex.exec(keyword_query);
	const dummy_condition = dummy_test !== null && dummy_test[0] === dummy_test.input;

	return (
		<Result>
			{/* 검색어 입력 전 */}
			{(keyword_query === null || keyword_query.trim() === '') && (
				<ResultNone type="search_yet" />
			)}
			{/* 검색 결과 존재 */}
			{data !== null &&
				!isLoading &&
				(!isFetching || isFetchingNextPage) &&
				(data.pages[0].count !== 0 ||
					exact_search_data.count !== 0 ||
					dummy_condition) && <SearchResultList />}
			{/* 검색 결과 없음 */}
			{data !== null &&
				!isLoading &&
				!isFetching &&
				data.pages[0].count === 0 &&
				exact_search_data.count === 0 &&
				!dummy_condition && <ResultNone type="search" />}
			{/* 로딩 */}
			{(isLoading || (isFetching && !isFetchingNextPage)) && (
				<style.Grid _height="calc(100vh - 400px)" flex="center">
					<CoreLoading color_type="black" />
				</style.Grid>
			)}
		</Result>
	);
};

const Result = styled.div`
	width: 100%;
	height: auto;
	min-height: calc(100% - 227px);
	padding: 16px;

	background-color: ${({ theme }) => theme.colors.gray.gray05_bg};

	border-radius: 0 0 16px 16px;
`;

export default SearchResult;
